import { useEffect } from 'react';
import { useRouter } from 'next/router';
import useAccount from '@/store/account';
import { getCookie } from '@/utils/cookie';
import Constant from '@/constants/const';
import { getCommonBarInfo } from '@/api/growth';
import usePageMountEffect from './usePageMountEffect';
import { getLoginState } from '@/utils/common/user';
import useSourceOfStudent from './source-of-student';

interface Props {
  source?: string;
}

/**
 * 顶部bar对接新接口
 *
 */
const useSyncPromoBarCopy = (props?: Props) => {
  const { syncCommonBarCopy } = useAccount();
  const { query } = useRouter();
  const { checkSourceOfStudent } = useSourceOfStudent();

  const getData = async () => {
    let postData: {
      referrer_id?: string;
      ep_partner?: string;
      channel_type?: string;
      source?: string;
      referral_type?: string;
      user_type?: string;
    } = {
      channel_type: (query.channel_type as string) || '',
      referral_type: (query.referral_type as string) || '',
      source: (props?.source as string) || ''
    };
    const referrer_id = getCookie(Constant.REFERRER_ID);
    if (referrer_id) {
      postData.referrer_id = referrer_id;
    }
    const ep_partner = getCookie(Constant.EP_PARTNER);
    if (ep_partner) {
      postData.ep_partner = ep_partner;
    }
    if (!getLoginState() && checkSourceOfStudent()) {
      postData.user_type = Constant.STUDENT_SOURCE;
    }
    const res = await getCommonBarInfo(postData);
    if (res?.result) {
      syncCommonBarCopy(res.object || {});
    }
  };

  usePageMountEffect(() => {
    getData();
  }, []);
};

export default useSyncPromoBarCopy;
